module.exports = __webpack_public_path__ + "assets/img/novel.de2b5640.png";